import type { Language } from "./types";

const languageNames: Record<Language, string> = {
  en: "English",
  ar: "عربي",
};

export const rtlLangs: Language[] = ["ar"];

export const locales: Record<Language, string> = {
  en: "en-GB",
  ar: "ar-AE",
};

export const DEFAULT_LANG: Language =
  (process.env.DEFAULT_LANGUAGE as Language) || "en";

const supportedCodes = process.env.LANGUAGES_SUPPORTED
  ? (process.env.LANGUAGES_SUPPORTED.split(",") as Language[])
  : (Object.keys(languageNames) as Language[]);

export const languages: Record<Language, string> = Object.fromEntries(
  supportedCodes.map((l) => [l, languageNames[l]]),
) as Record<Language, string>;

export const languageKeys = Object.keys(languages) as Language[];
